/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
}

.qds-chevron,
.qds-external {
  transform: scaleX(var(--qds-direction-factor, 1));
}

.qds-external {
  display: none;
}

.qds-icon {
  vertical-align: text-bottom;
  flex-shrink: 0;
}

.qds-standalone-link {
  align-items: center;
  border-radius: var(--qds-focus-border-radius);
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  print-color-adjust: exact;
  text-decoration: none;
  width: 100%;

  &[rel~='external'] > .qds-external {
    display: inline-block;
  }

  &:focus-visible {
    outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
    outline-offset: var(--qds-focus-border-offset);
  }

  &:hover,
  &:active {
    text-decoration: underline;
  }
}

[data-importance='subdued'] {
  color: var(--qds-theme-link-subdued-default);

  &:visited.qds-visitable {
    color: var(--qds-theme-link-visited-default);
  }

  &:hover {
    color: var(--qds-theme-link-subdued-hover);
  }

  &:active {
    color: var(--qds-theme-link-subdued-pressed);
  }

  &:visited:hover.qds-visitable {
    color: var(--qds-theme-link-visited-hover);
  }

  &:visited:active.qds-visitable {
    color: var(--qds-theme-link-visited-pressed);
  }
}

[data-importance='standard'] {
  color: var(--qds-theme-link-standard-default);

  &:visited.qds-visitable {
    color: var(--qds-theme-link-visited-default);
  }

  &:hover {
    color: var(--qds-theme-link-standard-hover);
  }

  &:active {
    color: var(--qds-theme-link-standard-pressed);
  }

  &:visited:hover.qds-visitable {
    color: var(--qds-theme-link-visited-hover);
  }

  &:visited:active.qds-visitable {
    color: var(--qds-theme-link-visited-pressed);
  }
}

[data-importance='emphasized'] {
  color: var(--qds-theme-link-emphasized-default);

  &:visited.qds-visitable {
    color: var(--qds-theme-link-visited-default);
  }

  &:hover {
    color: var(--qds-theme-link-emphasized-hover);
  }

  &:active {
    color: var(--qds-theme-link-emphasized-pressed);
  }

  &:visited:hover.qds-visitable {
    color: var(--qds-theme-link-visited-hover);
  }

  &:visited:active.qds-visitable {
    color: var(--qds-theme-link-visited-pressed);
  }
}

[aria-disabled='true'] {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

[data-size='small'] {
  &.qds-standalone-link {
    font: var(--qds-control-small-link);
    gap: var(--qds-control-small-gap-internal);
    padding-block: var(--qds-control-small-padding-auto-height);
  }

  &[data-importance='subdued'] {
    font: var(--qds-control-small-text);
  }

  &.qds-icon {
    height: var(--qds-control-small-icon-size);
    width: var(--qds-control-small-icon-size);
  }
}

[data-size='standard'] {
  &.qds-standalone-link {
    font: var(--qds-control-standard-link);
    gap: var(--qds-control-standard-gap-internal);
    padding-block: var(--qds-control-standard-padding-auto-height);
  }

  &[data-importance='subdued'] {
    font: var(--qds-control-standard-text);
  }

  &.qds-icon {
    height: var(--qds-control-standard-icon-size);
    width: var(--qds-control-standard-icon-size);
  }
}

[data-size='large'] {
  &.qds-standalone-link {
    font: var(--qds-control-large-link);
    gap: var(--qds-control-large-gap-internal);
    padding-block: var(--qds-control-large-padding-auto-height);
  }

  &[data-importance='subdued'] {
    font: var(--qds-control-large-text);
  }

  &.qds-icon {
    height: var(--qds-control-large-icon-size);
    width: var(--qds-control-large-icon-size);
  }
}
